import { render, staticRenderFns } from "./CompetitionRules2021.vue?vue&type=template&id=0fca7e2c&"
import script from "./CompetitionRules2021.vue?vue&type=script&lang=js&"
export * from "./CompetitionRules2021.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports